import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Zap, LogOut } from "lucide-react";

export default function Nav() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="print:hidden sticky top-0 z-30 border-b border-border bg-background/80 backdrop-blur-xl">
      <div className="mx-auto flex h-14 max-w-[1400px] items-center justify-between px-4 md:px-8">
        <Link
          to="/"
          data-testid="nav-logo-link"
          className="flex items-center gap-2 group"
        >
          <span className="grid h-7 w-7 place-items-center gold-metallic-bg text-black rounded-sm">
            <Zap size={16} strokeWidth={2.5} />
          </span>
          <span className="gold-metallic-text wordmark text-xl md:text-[22px]">
            Book Away
          </span>
          <span className="mono ml-2 hidden text-[10px] uppercase tracking-[0.2em] text-muted-foreground md:inline">
            last-minute openings
          </span>
        </Link>

        <nav className="flex items-center gap-1 text-sm">
          <Link
            to="/"
            data-testid="nav-explore-link"
            className="hidden px-3 py-1.5 text-muted-foreground hover:text-foreground transition-colors md:inline-block"
          >
            Explore
          </Link>
          {user && user.role === "business" && (
            <Link
              to="/dashboard"
              data-testid="nav-dashboard-link"
              className="px-3 py-1.5 text-muted-foreground hover:text-foreground transition-colors"
            >
              Dashboard
            </Link>
          )}
          {user && user.role === "consumer" && (
            <Link
              to="/my-requests"
              data-testid="nav-my-requests-link"
              className="px-3 py-1.5 text-muted-foreground hover:text-foreground transition-colors"
            >
              My Requests
            </Link>
          )}
          {user && user.is_admin && (
            <Link
              to="/admin"
              data-testid="nav-admin-link"
              className="mono px-3 py-1.5 text-[11px] uppercase tracking-widest text-[#C9A85F] hover:text-foreground transition-colors"
            >
              Admin
            </Link>
          )}
          {user ? (
            <>
              <span
                data-testid="nav-user-email"
                className="mono hidden px-3 py-1.5 text-xs text-muted-foreground md:inline"
              >
                {user.email}
              </span>
              <button
                data-testid="nav-logout-btn"
                onClick={async () => {
                  await logout();
                  navigate("/");
                }}
                className="inline-flex items-center gap-1.5 border border-border px-3 py-1.5 text-xs uppercase tracking-widest hover:bg-foreground hover:text-background transition-colors"
              >
                <LogOut size={12} />
                Logout
              </button>
            </>
          ) : (
            <>
              <Link
                to="/login"
                data-testid="nav-login-link"
                className="px-3 py-1.5 text-muted-foreground hover:text-foreground transition-colors"
              >
                Login
              </Link>
              <Link
                to="/register"
                data-testid="nav-register-link"
                className="bg-foreground text-background px-3 py-1.5 text-xs uppercase tracking-widest hover:bg-[#C9A85F] transition-colors"
              >
                For Business
              </Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
